import { useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import {
  capturePageView,
  identifyUser,
  registerSuperProperties,
} from '../lib/analytics'

function getPlaceIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/app\/([^/]+)/)
  return match ? match[1] : null
}

export default function AnalyticsProvider({ children }: { children: ReactNode }) {
  const location = useLocation()
  const auth = useAuth()

  useEffect(() => {
    capturePageView(location.pathname)
  }, [location.pathname])

  useEffect(() => {
    if (auth?.user) {
      identifyUser(auth.user.uid, {
        email: auth.user.email ?? undefined,
        name: auth.userProfile?.name ?? auth.user.displayName ?? undefined,
      })
    }
  }, [auth?.user, auth?.userProfile?.name, auth?.user?.email, auth?.user?.displayName])

  useEffect(() => {
    const placeId = getPlaceIdFromPath(location.pathname)
    if (placeId) {
      registerSuperProperties({ placeId })
    }
  }, [location.pathname])

  return <>{children}</>
}
